/*
 * @Author: bbqin
 * @Date: 2022-10-19 16:28:18
 * @LastEditTime: 2023-08-31 18:16:27
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\adapter\core\view.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from "react";
import { Input, Tooltip } from "@platform/base";
import Dnd from '../../libs/dnd';
import { match } from '../../libs/utils';
import classnames from 'classnames';
import { getSysFieldid } from '@platform/api';

/**
 * 左侧的属性面板
 */
class View extends Component {
    constructor(props) {
        super(props);
    }

    onSearch = (value, e) => {
        const { store, code } = this.props;
        const viewStore = store.getStore(['coreData', 'view']) || {};
        const { data = [] } = viewStore;

        const nextData = data.map(item => {
            const { label } = item;
            // 是否是过滤的
            item.filtered = match(label, value);
            return item;
        });

        store.setStore(['coreData', 'view', 'value'], value, false);
        store.setStore(['coreData', 'view', 'data'], nextData, true);

        // TODO search
        // scrollIntoView 聚焦到首项
    }

    onDragEnd = data => {
        const { store, code } = this.props;
        // TODO 设置数据
        store.setStore(['coreData', 'view', 'data'], data, false);
    }

    render() {

        const { store, code } = this.props;
        const langJson = store.getStore('langJson');
        const viewStore = store.getStore(['coreData', 'view']) || {};
        const { value, data = [] } = viewStore;

        return <div
            className="view-wrapper"
            fieldid={getSysFieldid('right_area')}
        >
            <div className="view-search">
                <span className="view-search-label">{langJson['view-list-title'] || '已添加'}</span>
                <Input
                    className="view-search-input"
                    placeholder={langJson['setting-search-placeholder'] || '请搜索'}
                    type="search"
                    value={value}
                    onChange={this.onSearch}
                    // onSearch
                    showClose
                />
            </div>
            <div className="view-list">
                <Dnd
                    data={data}
                    onDragEnd={this.onDragEnd}
                    getListItem={(item, i) => {
                        const { attrcode, islock } = item;
                        const next = data[i + 1];
                        const isLastLock = islock && !next?.islock;

                        return <ListItem key={attrcode} areaCode={code} store={store} {...item} isLastLock={isLastLock} />;
                    }}
                />
            </div>
        </div>;
    }
}

const getIconClass = (fontName, another) => {
    return `icon iconfont icon-${fontName} ${another}`;
};

class ListItem extends Component {
    constructor(props) {
        super(props);
    }

    // 右侧点击删除 不删除数据，改变数据的
    onTransferToSource = e => {
        const { store, areaCode, attrcode } = this.props;
        let nextFieldSourceItem = null;
        {
            // 右边移除一个
            const viewStore = store.getStore(['coreData', 'view']) || {};
            const { value, data = [] } = viewStore;
            const nextData = data.filter(item => {
                const { label, attrcode: currentCode } = item;
                if (currentCode === attrcode) {
                    // 记录数据
                    nextFieldSourceItem = item;
                    return false;
                } else {
                    // 是否是过滤的
                    item.filtered = match(label, value);
                    return true;
                }
            });
            store.setStore(['coreData', 'view', 'data'], nextData, false);
        }
        {
            // 左边添加一个
            const fieldStore = store.getStore(['coreData', 'field']) || {};
            const { value, data = [] } = fieldStore;
            // 显示
            nextFieldSourceItem.iscoredata = false;
            let nextData = nextFieldSourceItem ? [...data, nextFieldSourceItem] : data;

            nextData = nextData.map(item => {
                const { label } = item;
                // 是否是过滤的
                item.filtered = match(label, value);
                return item;
            });
            store.setStore(['coreData', 'field', 'data'], nextData, true);
        }
    };

    // 高亮/取消高亮
    onToggleHighLight = e => {
        const { store, areaCode, attrcode, ishighlight, isbold } = this.props;
        {
            // 更改状态
            const viewStore = store.getStore(['coreData', 'view']) || {};
            const { value, data = [] } = viewStore;

            const nextData = data.map(item => {
                const { label, attrcode: currentCode } = item;
                if (attrcode == currentCode) {
                    // item.ishighlight = !ishighlight;
                    item.isbold = !isbold;
                }

                item.filtered = match(label, value);

                return item;
            });

            store.setStore(['coreData', 'view', 'data'], nextData, true);
        }
    };

    render() {
        const {
            store,
            // 是否展示了
            showItem,
            isFilter,
            label,
            required,
            noDeletion,
            redstar,
            ishighlight,
            isbold,
            islock,
            isLastLock,
            filtered,
            visible
        } = this.props;
        const langJson = store.getStore('langJson');
        const uncontrolledVisible = store.getStore(['config', 'uncontrolledVisible']);

        return <div className="view-item">
            <div
                className={classnames({
                    'view-item-filtered': filtered,
                    'view-item-content': true,
                    'show-highlight': isbold,
                })}
            >
                {/* {required && <span className="unselected-mark iconfont icon-xinghao"></span>} */}
                <span className="view-label" title={label}>{label}</span>
                {
                    !islock && !uncontrolledVisible ?
                        <span className="view-icon" onClick={this.onTransferToSource}>
                            <Tooltip
                                placement="top"
                                overlay={langJson['action-icon-delete']}
                                delayHide={1}
                                delayShow={1000}
                            >
                                <i
                                    className={getIconClass('shenpibohui', 'moveToRight')}
                                    style={(noDeletion || redstar) ? { color: '#aeaeae', cursor: 'not-allowed' } : {}}
                                />
                            </Tooltip>
                        </span>
                        :
                        null
                }
                {/* <span className="view-icon icon-highlight" onClick={this.onToggleHighLight}>
                    <Tooltip
                        placement="top"
                        overlay={isbold ? langJson['action-icon-light'] : langJson['action-icon-unlight']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i className={getIconClass('gaoliang', isbold ? 'activated' : 'close')} />
                    </Tooltip>
                </span> */}
            </div>
        </div>;
    }
}

export default View;